import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-50-vijay-gokhale-guest.webp";
import ThumbImg from "../../assets/images/conversations/050.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: vg2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .vg2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .vg2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .vg2-hero { padding-top: 60px; padding-bottom: 60px; }
  .vg2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .vg2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .vg2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vg2-hero__title.vg2-visible { opacity: 1; transform: translateY(0); }
  .vg2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .vg2-hero__spotify.vg2-visible { opacity: 1; transform: translateY(0); }
  .vg2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .vg2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .vg2-hero__right.vg2-visible { opacity: 1; transform: translateY(0); }

  /* thumbnail */
  .vg2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .vg2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .vg2-yt-thumb:hover img { opacity: 0.85; }
  .vg2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .vg2-yt-thumb__play img { width: 40px; height: 44px; }
  .vg2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .vg2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .vg2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vg2-body.vg2-visible { opacity: 1; transform: translateY(0); }
  .vg2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .vg2-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .vg2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .vg2-guest.vg2-visible { opacity: 1; transform: translateY(0); }
  .vg2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .vg2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .vg2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .vg2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .vg2-inner { padding-left: 32px; padding-right: 32px; }
    .vg2-hero { padding-top: 32px; padding-bottom: 48px; }
    .vg2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .vg2-hero__title { font-size: 24px; }
    .vg2-hero__left { gap: 16px; }
    .vg2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .vg2-guest__photo-bg { width: 260px; height: 300px; }
    .vg2-guest__name { font-size: 24px; margin-top: 18px; }
    .vg2-body__para { font-size: 14px; margin-bottom: 12px; }
    .vg2-body { padding-bottom: 48px; }
    .vg2-guest { padding-bottom: 48px; }
    .vg2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .vg2-inner { padding-left: 16px; padding-right: 16px; }
    .vg2-hero { padding-top: 51px; padding-bottom: 30px; }
    .vg2-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .vg2-hero__left { gap: 30px; }
    .vg2-hero__title { font-size: 30px; }
    .vg2-body__para { font-size: 16px; margin-bottom: 10px; }
    .vg2-guest__title { font-size: 30px; margin-bottom: 20px; }
    .vg2-guest__photo-bg { width: 100%; height: 386px; }
    .vg2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .vg2-body { padding-bottom: 30px; }
    .vg2-guest { padding-bottom: 30px; }
    .vg2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("vg2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID ="";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="vg2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 50 Vijay Gokhale"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="vg2-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 50 Vijay Gokhale thumbnail" />
      <div className="vg2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="vg2-hero">
      <div className="vg2-inner">
        <div className="vg2-hero__grid">
          <div className="vg2-hero__left">
            <h1 ref={titleRef} className="vg2-hero__title">
              EP 50 | Unwrapping geopolitics with Vijay GOKHALE
            </h1>
            <div ref={spotifyRef} className="vg2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/4wqFmMkPQ3MmbUi5R5JD2T?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 50 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="vg2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="vg2-body">
      <div className="vg2-inner">
        <p className="vg2-body__para">
          In this episode, Vijay Gokhale, former Indian Foreign Secretary, delves into the complexities of global energy transitions and geopolitics. He discusses China's rapid technological advancements, strategic geopolitical maneuvers, and the global implications of energy resource control. Gokhale also provides insights into India's strategic positioning, technological growth, and the intricate balance of international relations. Join us for an engaging discussion on the challenges and opportunities shaping the 21st-century geopolitical landscape.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="vg2-guest">
      <div className="vg2-inner">
        <h2 className="vg2-guest__title">Our Guest</h2>
        <div>
          <div className="vg2-guest__photo-bg">
            <img src={GuestImg} alt="Vijay Gokhale" />
          </div>
          <p className="vg2-guest__name">Vijay Gokhale</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep50VijayGokhale() {
  return (
    <>
      <style>{CSS}</style>
      <div className="vg2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}